<template>

  <div class="d-flex h-full flex-column">
					<TopAppBar
						:leftBtnMode="leftBtnMode"
						:rightBtnMode="rightBtnMode"
						:title="titleBrand"
						:leftBtnMethod="leftBtnMethod"
						:rightBtnMethod="rightBtnMethod"
            :hideCategory="true"
						staticMode="true"
					>
					</TopAppBar>
		<div class="desktop-nav">
			 <TopAppBarDrawer></TopAppBarDrawer>
			<div class="mdc-drawer-scrim transition"></div>
		</div>
		<main class="main-wrapper flex-grow-1">
			<div class="t-headline13 t-color-headlineBlack pda-16 t-center font-m t-line-h-32">{{$t('863')}}</div>
			<!-- <div class="view-details-header bg-primary position-relative">
				<div class="header-image"><img src="images/header-banner.svg" alt=""></div>
				<div class="header-overlay"></div>
				<div class="container container--narrow position-relative pdt-30 pdb-30 pdl-16 pdr-16">
					<div class="t-headline11 t-color-whiteHigh font-m">
						디지털 미디어 애널리스트 : 소셜 네트워크 서비스
					</div>
					<div class="t-body6 t-color-whiteHigh font-r pdt-16 pdb-12">
						차수분류1 > 차수분류2
					</div>
					<div class="t-body6 t-color-whiteHigh font-r pdb-12">
						차수레벨
					</div>
					<div class="mdc-chip-set banner--chip chip--outlined" role="grid">
						<div class="mdc-chip " role="row">
							<div class="mdc-chip__ripple"></div>
							<span role="gridcell">
								<span class="mdc-chip__text">테그1</span>
							</span>
						</div>
						<div class="mdc-chip" role="row">
							<div class="mdc-chip__ripple"></div>
							<span role="gridcell">
								<span class="mdc-chip__text">테그1</span>
							</span>
						</div>
						<div class="mdc-chip" role="row">
							<div class="mdc-chip__ripple"></div>
							<span role="gridcell">
								<span class="mdc-chip__text">테그1</span>
							</span>
						</div>
					</div>
					<div class="d-flex align-items-baseline justify-content-between mgt-24">
						<div class="d-flex align-items-baseline pdb-24">
							<div class="t-body-6 pdr-4 t-color-appbarText">KRW</div>
							<div class="t-headline5 pdr-8  t-color-whiteHigh font-b font-rb">15,000</div>
							<div class="t-body1 t-color-whiteMedium t-line-through-red">22,000</div>
						</div>
						<div class="t-body1 t-color-whiteMedium font-r">(정원 67 / 123)</div>
					</div>
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">구매하기</span>
					</button>
				</div>
			</div> -->
			<div class="divider"></div>
			<!-- subtabs -->
			<!-- <div class="subtabs d-none">
				<div class="mdc-tab-bar main-tabs" role="tablist">
					<div class="mdc-tab-scroller ">
						<div class="mdc-tab-scroller__scroll-area">
							<div class="mdc-tab-scroller__scroll-content justify-content-center">
								<button class="mdc-tab " role="tab" aria-selected="true" tabindex="0">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">과정 개요</span>
									</span>
									<span class="mdc-tab-indicator ">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
								<button class="mdc-tab mdc-tab--active" role="tab">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">레슨</span>
									</span>
									<span class="mdc-tab-indicator mdc-tab-indicator--active">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
								<button class="mdc-tab " role="tab">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">리워드</span>
									</span>
									<span class="mdc-tab-indicator ">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
								<button class="mdc-tab" role="tab">
									<span class="mdc-tab__content">
										<span class="mdc-tab__text-label font-m t-body2">수료증</span>
									</span>
									<span class="mdc-tab-indicator ">
										<span
											class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
									</span>
									<span class="mdc-tab__ripple"></span>
								</button>
							</div>
						</div>
					</div>
				</div>

				<div class="divider divider-subtabs"></div>
			</div> -->

		   <NoData v-if="isNoData==true"></NoData>
			<div class="container container--narrow pdt-26">
				<div class="pdt-24 pdb-24"  v-if="reviewData.length>0" >
					<div class="d-flex align-items-center mgb-19" v-if="reviewSummaryData && reviewSummaryData.average !=null" >
						<div class="t-headline5 font-b   mgr-8" v-if="reviewSummaryData" >{{reviewSummaryData && reviewSummaryData.average !=null?reviewSummaryData.average.toFixed(2):''}}</div>
						<div class="t-headline7 font-m   mgr-12 t-color-bodyGrayA">{{reviewSummaryData && reviewSummaryData.average !=null? $t('864'):''}}</div>
					</div>


<div class="d-flex pdt-16 pdb-16 list-with-submenu" :class="personalInfo && personalInfo.userId == review.reviewer.email?'bg-primaryHover':''" v-for="(review, index) in reviewData" :key="index" >
			<UserImgProfile :data="review.reviewer" />
			<div class="flex-grow-1 pdl-16 mgb-4">
							<div class="d-flex position-relative">
								<i
										v-for="i in 5"
										:key="i"
								:class="i <= review.score ? 'material-icons t-color-starmark t-headline8' : 'material-icons t-color-textfieldGuidLine t-headline8'"
								>star</i>
								<i 
									class="material-icons mdc-icon-button dkk3 t-headline6 js--dropdown-toggle t-color-iconInactive more-icon" 
									tabindex="0"
									@click="handleModal(review.id)"
									@keypress="handleModal(review.id)"
								>
									more_horiz
								</i>

								<UserDetailActionModal 
									v-if="isOpenModal && selectedId === review.id"
									:type="'REVIEW'"
									:data="review"
									:selectedChild="makeSelectedChild()"
									@report="goToReport(review)"
									@block="handleBlock"
									@edit="editReview(review.id)"
									@delete="deleteReview(review.id)"
									:className="'action-modal'"
								/>
							</div>
							<div class="t-body1 mgb-8 font-r mgt-4" :class="{'t-color-bodyGrayB': review.isBlocked}">
											{{ review.isBlocked ? $t("3814") : review.content }}
							</div>
							<div class="d-flex align-items-baseline" >
								<div class="t-body3  t-color-bodyGrayA font-r mgr-8" :class="{'t-color-bodyGrayB': review.isBlocked}">{{ $t("3437", { first: review.reviewer.name.first, last: review.reviewer.name.last }) }}</div>
								<div class="t-body3 font-r t-color-bodyGrayA mgr-8" :class="{'t-color-bodyGrayB': review.isBlocked}">{{$moment(review.created).fromNow()}}</div>
							</div>
						</div>

						<!-- <div class="pdl-16 mgr-24 position-relative mdc-menu-anchor menu-container cursor-pointer" v-if="personalInfo && personalInfo.userId == review.reviewer.email">
							<i
								class="material-icons t-color-iconInactive t-headline14 js--dropdown-toggle"  @click.prevent="toggleMethod(review.id)" @keypress.prevent="toggleMethod(review.id)" tabindex="0">more_horiz</i>

							<div class="mdc-menu mdc-menu-surface toggle-menu" :class="'toggle-menu_open_'+review.id" >
								<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical"
									tabindex="-1">
									<li class="mdc-list-item" role="menuitem" @click.prevent="editReview(review.id)" @keypress.prevent="editReview(review.id)" tabindex="0">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">{{$t('1929')}}</span>
									</li>
									<li class="mdc-list-item" role="menuitem" @click.prevent="deleteReview(review.id)" @keypress.prevent="deleteReview(review.id)" tabindex="0">
										<span class="mdc-list-item__ripple"></span>
										<span class="mdc-list-item__text t-body6 font-r t-color-headlineBlack">{{$t('1930')}}</span>
									</li>
								</ul>
							</div>
						</div> -->
					</div>
				</div>
				</div>
			</main>
					<div class="footer bg-white bottomStack">
						<div class="divider"></div>
						<div class="container container--narrow pdb-0">
							<div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
								<div class="d-flex align-items-baseline ">
												<!-- <div class="t-body-6 pdr-4">KRW</div>
												<div class="t-headline5 pdr-8">15,000</div> -->
								</div>
								<div>
									<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText dldk" @click="goBackScreen" @keypress="goBackScreen" tabindex="0">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r">{{$t('3309')}}</span>
									</button>
								</div>
							</div>
						</div>
					</div>
					<div v-if="isOpenModal" @click="closeModal" @keypress="closeModal" class="modal-background" />
    </div>
</template>

<script>
import degreeApi from '@/api/degreeApi.js'
import NoData from "../../common/NoDataDegreeReviewList.vue";
import learnApi from '@/api/learnApi.js'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import TopAppBar from "@/components/TopAppBar.vue";
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import { userMixin } from '@/mixins/user';
import UserDetailActionModal from '@/components/common/modal/UserDetailActionModal.vue';
import snackMessage from "@/plugins/snackMessage";

export default {
  data() {
		return {
			title: this.$t('course.view.morereview'),
			reviewData: [],
			reviewSummaryData: {},
			totalPages: 0,
			currentPage: 1,
			personalInfo:'',
			reviewOwner:'',
			isNoData: false,
			writePermission: false,
			titleBrand:localStorage.getItem('brandName'),
			paramsss : JSON.parse(localStorage.getItem("courseParams")),
			isOpenModal: false,
			selectedId: null,
		}
	},
	components: {
    NoData,
    TopAppBarDrawer,
    TopAppBar,
    UserDetailActionModal,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
},
	mixins: [topAppBarMixin, userMixin],
	watch:{
	  '$route' (to, from){
		let getType = this.$route.query.type;
			if(getType == 'delete') {
			  this.reviewData=[];
			  this.fetchData()
		}
	  },
	},
	beforeMount () {


	},
	mounted() {
	  //   $('#grade_toggler').click(function(){
	  //     $(this).next('.toggle-menu').toggleClass('toggleX300');
	  //  })
		this.fetchData()
		document.addEventListener('scroll', () => {

		})
	  learnApi.getMemberInfo().then((response)=>{
		let memberDetail = response.data.data;
		this.personalInfo = memberDetail;

	  })


//       if(document.querySelectorAll('.toggle-menu')){
//     const menuEls = Array.from(document.querySelectorAll('.toggle-menu'));
//         menuEls.forEach((menuEl) => {
//             // Initialize MDCSimpleMenu on each ".mdc-simple-menu"
//             const menu = new mdc.menu.MDCMenu(menuEl);
//             // We wrapped menu and toggle into containers for easier selecting the toggles
//             const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
//             dropdownToggle.addEventListener('click', () => {
//                 menu.open = !menu.open;
//             });
//         });
// }

	},
	updated() {

	},

	computed: {
		isLastPage() {
			return this.totalPages !== null && this.totalPages <= this.currentPage ? true : false
		},
	},
	 methods: {
		goBackScreen(){
			//http://52.78.24.10:8559/degree/853?type=ListTotal)
			this.$router.push({
						name: "DegreeView",
						params: { degreeId: this.$route.params.id },
						query:{type : 'ListTotal'}
					});
		},
	   toggleMethod(id){
		  const menu = new mdc.menu.MDCMenu($('.toggle-menu_open_'+id)[0]);
		  menu.open = !menu.open;
	   },
		fetchData() {
			let responseData = null
			let params = this.setParams()
			this.$showLoading()

			 degreeApi.authPermission(params).then((reponse)=>{
				this.writePermission = reponse.data.data.registrationAuth
			}).catch((err) => {
			})

			//과정 리뷰 평점(review summary)
			degreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
				this.reviewSummaryData = response.data.data
			}).catch((err) => {
			})

			degreeApi.learnOnlineViewReview(params).then((response) => {
				responseData = response.data.data
				this.totalPages = responseData.totalPages
				this.reviewData = this.reviewData.concat(responseData.content)
				//console.log('this.reviewData',this.reviewData.length)
				this.reviewOwner = this.reviewData && this.reviewData.reviewer?this.reviewData.reviewer.email:'';
				this.$hideLoading()
				if(this.reviewData.length>0) {
				  this.isNoData = false
				} else {
				  this.isNoData = true
				}
			}).catch((err) => {
			  this.$hideLoading()
				responseData = err.response.data.meta
				this.$error({content: responseData.errMsg}).then(() => {})
			})
		},

		setParams() {
			const params = {
				degreeId: this.$route.params.id,
			}
			return params
		},

		scrollPage(el) {
			let bottomOfWindow = el.scrollTop + window.innerHeight === document.getElementById('review_container').offsetHeight

			if (bottomOfWindow) {
				if (this.isLastPage) return false
				this.currentPage++
				this.fetchData()
			}
		},

	  moveReviewPost() {
		  this.$router.push('/review-post/'+this.$route.params.id)
	  },

	  editReview(editId){
		this.$router.push('/review-edit/'+this.$route.params.id+'/'+editId)
	  },
	getFirstLetter(name) {
		let firstCharOfName = name.trim().slice(0,1);
		//localStorage.setItem('firstChar', firstCharOfName)
		return firstCharOfName;
	},

	getRandomColor(){
		let colors = ['#fb6262', '#d16443d4', '#4d9fd6', '#40bca7', '#9db82f','#76a0d6', '#a967d4', '#696481', '#4c438d', '#fe7947'];
		let randomColor = colors[Math.floor(Math.random() * colors.length)];
		//localStorage.setItem('bgColors', `background-color:${randomColor}`)
		return `background-color:${randomColor}`
	},
	deleteReview(id){
			this.$confirm({
						title: '',
						content: this.$t("1934"),
						accept: this.$t("1936"),
						cancel: this.$t("1935"),
					}).then(() => {
						this.deleteConfirm(id);
					}).catch(() => {
					//	alert('cancel')
				});
	},
	deleteConfirm(id){
				this.$showLoading(this.$refs.loading);
			  let paramss = {
					degreeId: this.$route.params.id,
					reviewId: id
	  };
		degreeApi.learnDeleteReview(paramss).then((response) => {
		  this.$hideLoading();
		  this.$router.push('/review-list/'+this.$route.params.id+'?type=delete')
		})
		.catch((err) => {
		  this.$hideLoading();
		});
		this.$hideLoading();
	},

	// 유저 차단
	async handleBlock(item, isBlocked) {
      try {
        await this.blockUser(item, isBlocked, "REVIEW");
		this.reviewData = [];
		this.fetchData()
      } catch (error) {
        console.log("BOARD BLOCK ERROR : ", error);
      } finally {
        this.closeModal();
      }
    },

	goToReport(data) {
	  this.closeModal();
      if (!data.hasReported) {
        this.$router.push({
          name: "ReasonChoice",
          query: { ...this.$route.query, type: "REVIEW" },
          params: { data, degreeId: this.$route.params.id }
        })
      } else {
        this.closeModal();
        snackMessage(this.$t("3808"));
      }
    },

     // modal handle function
    handleModal(id) {
      this.isOpenModal = !this.isOpenModal;
      this.selectedId = id;
    },

    // modal close function
    closeModal() {
      this.isOpenModal = false;
      this.selectedId = null;
    },

	makeSelectedChild() {
      return {
        modify: true,
        remove: true,
      };
    },

	}
};
</script>
<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 var(--Shadow1);
  background-color: var(--DocumentWhite);
}

.tabs .tab {
  width: 50%;
}
.l-spacing78 {
  letter-spacing: -0.78;
}
.rating-wrapper.active {
  background: rgba(49, 61, 75, 0.05);
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
}
.active #grade_toggler {
  display: block;
}
span.grade {
  color: #acb4be;
  font-size: 14px;
}
span.grade.selected {
  color: #f6bb00;
}
#grade_toggler {
  color: #acb4be;
  cursor: pointer;
  display: none;
}
.toggle-menu {
  width: 112px;
  /* height: 112px; */
  right: -2px;
  top: 0px;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  transition: all 300ms ease-in-out;
  z-index: 99;
  box-sizing: border-box;
}
html[dir="rtl"] .toggle-menu {
  width: 112px;
  /* height: 112px; */
  left: -2px;
}
.toggle-menu > div {
  cursor: pointer;
}
.toggleX300 {
  transform: translateX(300px);
}

.more-icon {
  margin-left: auto;
  opacity: 1 !important;
  padding: 0;
  height: 0;
}

.action-modal {
  opacity: 1;
  min-width: 160px !important;
  top: 0 !important;
  right: 0 !important;
  margin-right: 10px;
  margin-top: 30px;
}

.modal-background{
  background: rgba(0, 0, 0, 0.001);
  z-index: 2;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.list-with-submenu .toggle-menu {
  top: 0px !important;
}
</style>
